var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.src ? 'img' : 'div',_vm._b({tag:"component",staticClass:"emblem",class:_vm.borderColor,attrs:{"src":_vm.src,"alt":_vm.label}},'component',_vm.$attrs,false),[_vm._v(_vm._s(_vm.src ? undefined : _vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }